import React from 'react';

function Logo({ size }) {
  return (
    <svg
      width={size || 420}
      height={size || 420}
      viewBox="0 0 420 420"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.375 10H110.625C118.564 10 125 16.4359 125 24.375V110.625C125 118.564 118.564 125 110.625 125H24.375C16.4359 125 10 118.564 10 110.625V24.375C10 16.4359 16.4359 10 24.375 10Z"
        fill="#22C55E"
      />
      <path
        d="M167.375 10H253.625C261.564 10 268 16.4359 268 24.375V110.625C268 118.564 261.564 125 253.625 125H167.375C159.436 125 153 118.564 153 110.625V24.375C153 16.4359 159.436 10 167.375 10Z"
        fill="#EAB308"
      />
      <path
        d="M309.375 10H395.625C403.564 10 410 16.4359 410 24.375V110.625C410 118.564 403.564 125 395.625 125H309.375C301.436 125 295 118.564 295 110.625V24.375C295 16.4359 301.436 10 309.375 10Z"
        fill="#3D3D66"
      />
      <path
        d="M24.375 153H110.625C118.564 153 125 159.436 125 167.375V253.625C125 261.564 118.564 268 110.625 268H24.375C16.4359 268 10 261.564 10 253.625V167.375C10 159.436 16.4359 153 24.375 153Z"
        fill="#3D3D66"
      />
      <path
        d="M167.121 153H353.516C384.711 153 410 178.744 410 210.5C410 242.256 384.711 268 353.516 268H167.121C159.322 268 153 261.564 153 253.625V167.375C153 159.436 159.322 153 167.121 153Z"
        fill="#22C55E"
      />
      <path
        d="M66.4706 295H353.529C384.717 295 410 320.744 410 352.5C410 384.256 384.717 410 353.529 410H66.4706C35.2827 410 10 384.256 10 352.5C10 320.744 35.2827 295 66.4706 295Z"
        fill="#22C55E"
      />
    </svg>
  );
}

export default Logo;
